import React from 'react';
import { render } from 'react-dom';
import App from './components/App.react';
import Dashboard from './components/Dashboard.react';
import Configurator from './components/Configurator.react';
import Cart from './components/Cart.react';
import NotFound404 from './components/NotFound404.react';
import Logout from './components/Logout.react';
import {Router, Route, hashHistory, IndexRoute} from 'react-router';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, combineReducers} from 'redux';
import rootReducer from './reducers/index';
import thunkMiddleware from 'redux-thunk'
import * as AppActions from './actions/app';
import { IntlProvider, intlReducer, updateIntl } from 'react-intl-redux';
import { addLocaleData } from 'react-intl';
import deLocaleData from 'react-intl/locale-data/de';
import frLocaleData from 'react-intl/locale-data/fr';
import { routerMiddleware } from 'react-router-redux';
import 'babel-polyfill';
import areIntlLocalesSupported from 'intl-locales-supported';
import IntlPolyfill from 'intl';


// This section initialize an intl polyfill, if its not build in - eg. on iOS 9 / Safari
const supportedLocales = [
    'en', 'fr', 'de'
];
if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!areIntlLocalesSupported(supportedLocales)) {
        // `Intl` exists, but it doesn't have the data we need, so load the
        // polyfill and replace the constructors with need with the polyfill's.
        Intl.NumberFormat   = IntlPolyfill.NumberFormat;
        Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
} else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = IntlPolyfill;
}

// Dipsatch logger, TODO ... configure only for dev mode
const logger = store => next => action => {
    console.log('dispatching', action)
    let result = next(action)
    console.log('next state', store.getState())
    return result
};

let store = createStore(
    rootReducer,
    applyMiddleware(logger, thunkMiddleware, routerMiddleware(hashHistory))
);

// TODO ... move this and load by config settings
addLocaleData([
    ...deLocaleData,
    ...frLocaleData,
]);

// load app config + intl
store.dispatch(AppActions.getAppConfig());

render(
    <Provider store={store}>
        <IntlProvider>
            <Router history={hashHistory}>
                <Route path="/" component={App}>
                    <IndexRoute component={Dashboard}/>
                    <Route path="/dashboard" component={Dashboard} />
                    <Route path="/configurator/:documentId/:storageId/:pageId" component={Configurator} />
                    <Route path="/configurator/:documentId/:storageId/:pageId/:isCopy" component={Configurator} />
                    <Route path="/logout" component={Logout} />
                    <Route path="/cart" component={Cart} />
                    <Route path="*" component={NotFound404}/>
                </Route>
            </Router>
        </IntlProvider>
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/js/main.js